import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex flex-column align-items-start justify-content-between gap-2">
          <h4 className="mb-sm-0 font-size-18 text-capitalize">
            {props.subBreadcrumbItem || props.breadcrumbItem}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to="#">{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
              {props.subBreadcrumbItem ? (
                <BreadcrumbItem>
                  <Link to="#">{props.subBreadcrumbItem}</Link>
                </BreadcrumbItem>
              ) : null}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  subBreadcrumbItem: PropTypes.string,
}

export default Breadcrumb
